import { Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from "moment";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import React, { useState } from 'react'
import {  ValidatorForm } from 'react-material-ui-form-validator';
import { startAlerta } from '../../../actions/ui/alertas';
import { useDispatch } from 'react-redux';
import { putModificarInternacion } from '../../../actions/autorizaciones/Autorizaciones';

export const CambioFechas = (props) => {
    const { solicitud } = props;
    const dispatch = useDispatch();
    const [fechaInicio, setFechaInicio] = useState(solicitud.fechaIngreso);
    const [fechaFin, setFechaFin] = useState(solicitud?.fechaEgreso);

    const onSubmitHandler = () => {
        if (moment(fechaFin).isBefore(moment(fechaInicio))) {
            dispatch(startAlerta("La Fecha de Fin no puede ser menor que la Fecha de Inicio", 'error', 'Error'));
        }
        else {
            const data = {
                idSolicitud: solicitud.idSolicitud,
                fechaInicio: fechaInicio,
                fechaFin: fechaFin
            }
            dispatch(putModificarInternacion(data, solicitud.idAfiliado));
            props.closeModalHandler();
        }
    }


    const onClose = () => {
        props.closeModalHandler(false);
    };


    return (
        <React.Fragment>
            <Dialog
                fullWidth
                maxWidth="md"
                open={props.open}
                onClose={props.close}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle>Cambio fechas </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        ID: {solicitud.idSolicitud}
                    </Typography>
                    <Typography variant="body1">
                        Beneficiaria/o: {solicitud.apellidoNombre}
                    </Typography>
                    {/* Otros elementos de contenido si es necesario */}
                </DialogContent>
                <DialogContent
                    style={{ overflowY: 'auto', maxHeight: '40vh', maxWidth: '100vw' }}
                >
                    <ValidatorForm onSubmit={onSubmitHandler}>
                        <Grid container spacing={2}>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={6}
                                lg={6}
                                style={{ alignSelf: 'center', paddingLeft: 16 }}
                            >
                                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        label="Fecha Inicio"
                                        format="dd/MM/yyyy"
                                        // required={true}
                                        clearLabel="Limpiar"
                                        cancelLabel="Cancelar"
                                        value={
                                            moment(fechaInicio).isValid() ? moment(fechaInicio).format() : null
                                        }
                                        onChange={(date) => {
                                            setFechaInicio(date);
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={6}
                                lg={6}
                                style={{ alignSelf: 'center', paddingLeft: 16 }}
                            >
                                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        label="Fecha Egreso"
                                        format="dd/MM/yyyy"
                                        // required={true}
                                        clearLabel="Limpiar"
                                        disabled={solicitud.fechaEgreso ? false : true}
                                        cancelLabel="Cancelar"
                                        value={
                                            moment(fechaFin).isValid() ? moment(fechaFin).format() : null
                                        }
                                        onChange={(date) => {
                                            setFechaFin(date);
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                        </Grid>
                        <div
                            style={{
                                marginTop: "2rem",
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-evenly',
                            }}
                        >
                            <Button variant="contained" color="primary" onClick={onClose}>
                                Cancelar
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                //disabled={props.disabled}
                                color="primary"
                            >
                                Guardar
                            </Button>
                        </div>
                    </ValidatorForm>
                </DialogContent>
            </Dialog>

        </React.Fragment >
    )
}
